import PropTypes from 'prop-types'
import React, { useEffect, Fragment } from 'react'
import { useQuery } from '@apollo/client'
import get from 'lodash/get'
import { GET_CONTENT } from 'Queries'
import NotFound from './component/NotFound'
import View from './component'
import {
  Spinner,
  ErrorView,
  PageView,
  PageHelmet,
  TrackLinkDecrease,
  JourneyTracker,
  StoreLocation
} from 'Blocks'
import { PAGE_CONTEXT as p } from 'Constants'

const pageName = p.INSTALOOK

const InstalookPageContainer = props => {
  // componentDidMount () {
  //   this.loadInstagram()
  // }

  // componentDidUpdate (prevProps) {
  //   if (prevProps.location.pathname !== this.props.location.pathname) {
  //     this.loadInstagram()
  //   }
  // }

  function loadInstagram() {
    if (typeof window !== 'undefined') {
      setTimeout(() => {
        window.instgrm.Embeds.process()
      }, 1000)
    }
  }

  useEffect(() => {
    loadInstagram()
  }, [])

  const matchParams = props.match.params

  const variables = {
    arguments: {
      uuid: matchParams.uuid,
      state: 'PUBLISHED'
    }
  }

  const queryString = get(props.location, 'search', '')
  if (queryString.match(/preview=1/)) {
    delete variables.arguments.state
  }

  const { loading, error, data } = useQuery(GET_CONTENT, { variables })
  const description = get(data, 'content.layout.intros[0].data', '')

  if (loading) {
    return <Spinner className="spinner" />
  }
  if (error) return <ErrorView message={error.message} error={error} />

  if (data.content) {
    return (
      <Fragment>
        <PageView url={props.location.pathname} />
        <PageHelmet
          pageName={pageName}
          titleFormat={{ INSTALOOK_TITLE: data.content.title.long }}
          description={description}
        />
        <TrackLinkDecrease url={props.location.pathname} />
        <StoreLocation location={props.location} />
        <JourneyTracker
          routeName={pageName}
          name={pageName}
          location={props.location}
          params={props.match.params}
        />
        <View
          location={props.location}
          params={matchParams}
          screenType={props.screenType}
          data={data}
        />
      </Fragment>
    )
  }
  return <NotFound />
}

InstalookPageContainer.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.any
  }),
  match: PropTypes.shape({
    params: PropTypes.shape({
      uuid: PropTypes.any
    })
  }),
  screenType: PropTypes.any
}

export default InstalookPageContainer
